export default __webpack_public_path__ + "static/media/ABI_05.5b95efc3.jpg";